import {Injectable} from '@angular/core';
import {DefaultDataServiceConfig, Logger,} from '@ngrx/data';
import {HttpClient} from '@angular/common/http';
import {AbstractDataServiceV2} from '../../../../../../core/service/v2/dataservice/abstractDataServiceV2';
import {CustomizeHttpUrlGenerator} from '../../../../../../../store/core/url/customizeHttpUrlGenerator';
import {Scanner3dAccountModel} from '../../../api/entity/scanner3dAccount.model';
import {Scanner3dAccountConverter} from '../../../api/entity/converter/scanner3dAccount.converter';

@Injectable()
export class Scanner3dAccountDataService extends AbstractDataServiceV2<Scanner3dAccountModel, Scanner3dAccountConverter> {
    constructor(http: HttpClient, httpUrlGenerator: CustomizeHttpUrlGenerator, logger: Logger, config: DefaultDataServiceConfig,
                converter: Scanner3dAccountConverter) {
        super('Scanner3dAccount', http, httpUrlGenerator, logger, config, converter);
    }
}
